function Install() {
    return (
      <div className="Install main-page">
        install
      </div>
    );
  }
  
  export default Install;